import baseAPI from '@/http'

const router = 'api/potencial'

export const potencialApi = {
    create: (potencial) => baseAPI.post(router, potencial),
    update: (potencial) => baseAPI.put(router, potencial),
    delete: (id) => baseAPI.delete(`${router}/${id}`),
    list: () => baseAPI.get(router),
    find: (id) => baseAPI.get(`${router}/${id}`),
    getByMunicipio: (municipioId) => baseAPI.get(`${router}/obter-potencial-por-municipio/${municipioId}`),

}
